//设置优惠券列表
export const SET_COUPON_LIST = 'SET_COUPON_LIST'
//选择优惠券
export const SET_COUPON_NO = 'SET_COUPON_NO'
//是否使用积分兑换
export const SET_USE_INTEGRAL = 'SET_USE_INTEGRAL'
//是否选择配送
export const SET_IS_DISTRIBUTE = 'SET_IS_DISTRIBUTE'
